<template>
    <main-layout>
        <div class="-pt-nav -pb-xs1-4 -pb-sm-12 background__icons-sm">
            <div class="container">
                <SectionDownloads />
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import SectionDownloads from "../components/sections/SectionDownloads.vue";

export default {
    components: {
    MainLayout,
    SectionDownloads,
},
    computed: {
    }
};
</script>
